module.exports = {
  OK: 'OK',
  CANCEL: 'Cancel',
  login_TITLE: 'Login',
  login_USERNAME: 'User Name: ',
  login_PASSWORD: 'Password: ',
  login_LANGUAGE: 'Language:',
  login_failure: 'Invalid user name or password',
  login_SAVEPASSWORD: 'Save Password',
  main_title: 'Cargo Management',
  main_user: 'User:',
  main_office: 'Office:',
  main_LOGOUT_TOOLTIP: 'Logout.',
  main_CHANGE_PASSWORD_TOOLTIP: 'Change password.',
  main_REFRESH_TOOLTIP: 'Refresh cached data.',
  main_HELP_TOOLTIP: 'Open help web page.',
  main_LOADING_MODULE_STATUS: 'Loading module {0} ...',
  main_INITIALIZING_STATUS: 'Initializing ...',
  main_REFRESHING_STATUS: 'Refreshing cached data ...',
  password_title: 'Change Password:',
  password_oldPassword: 'Old Password:',
  password_newPassword: 'New Password:',
  password_confirmTheNewPassword: 'Confirm The New Password:',
  password_confirmPassword: 'Confirm Password:',
  password_notMatch: 'Passwords do not match',
  password_notCompliant: 'パスワードは8～20文字で、数字、大文字、小文字をそれぞれ1文字以上含めてください。',
  password_noChange: 'New password cannot be the same as the old one.',
  password_failed: 'Change password failed. Please check you passwords, and try again.',
  PleaseEnterAOldPassword: 'Please enter the old password.',
  PleaseEnterANewPassword: 'Please enter a new password.',
  PleaseEnterTheConfirmationPassword: 'Please enter the confirmation password.',
  TheNewPasswordDoesNotMatchTheConfirmedNewPassword: 'The new password does not match the confirmed new password.',
  TheNewPasswordDoesNotMatchTheOldPassword: 'The new password does not match the old password.'
}
